import { useFormDataQuery, useIssueTypeQuery } from '@/api/getters';
import { summaryStages } from '@/api/types';
import ClientCard from '@/components/ui/ClientCard';
import { PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';
import { ISSUE_TYPE_NAME } from '@/features/v2/hh/components/SelectIssueType';
import { useStepper } from '@/features/v2/lib/stepper';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

const ClientCardHHSurveys = ({ className }: { className?: string }) => {
  const { i18n } = useLingui();
  const { data } = useFormDataQuery();
  const { watch } = useFormContext();
  const { step, innerStep } = useStepper();

  const issueTypeFromBe = data?.product.additional_info.issue_type?.label;

  const { data: issueTypeData } = useIssueTypeQuery(!issueTypeFromBe);

  const getIssueTypeHH = () => {
    if (issueTypeFromBe) {
      return issueTypeFromBe;
    }
    if (step >= 1 || innerStep >= 1) {
      return issueTypeData?.find(
        (item) => item.value === watch(ISSUE_TYPE_NAME)
      )?.label;
    }
  };

  const issueTypeHH = getIssueTypeHH() || i18n.t('Brak');

  if (!data) return null;

  return (
    <ClientCard
      leadID={data.id}
      opportunityID={data.offer.opportunity_id}
      purchaseID={data.offer.purchase_id}
      crmUser={
        data.crm_user?.name
          ? {
              name: data.crm_user.name,
              avatar: data.crm_user.avatar,
            }
          : undefined
      }
      userData={{
        ...data.user,
        phoneNumber: data.user.phone,
        issueTypeHH: issueTypeHH,
      }}
      guardian={CONSULTANTS.MARTA_ASSISTANT}
      isSummaryForm={!!summaryStages.includes(data.stage)}
      className={className}
      productId={PRODUCT.HOUSE_HOLD}
    />
  );
};

export default ClientCardHHSurveys;
